import { render, staticRenderFns } from "./wrongTopic.vue?vue&type=template&id=56c3d1ef&scoped=true"
import script from "./wrongTopic.vue?vue&type=script&lang=js"
export * from "./wrongTopic.vue?vue&type=script&lang=js"
import style0 from "./wrongTopic.vue?vue&type=style&index=0&id=56c3d1ef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c3d1ef",
  null
  
)

export default component.exports